import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-569509f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search el-input__icon fas" }, null, -1))
const _hoisted_4 = { class: "map" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_marker_cluster = _resolveComponent("marker-cluster")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: _ctx.query,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
        disabled: ""
      }, {
        prefix: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_l_map, {
        ref: "map",
        "max-zoom": 21,
        center: _ctx.defPosition,
        zoom: _ctx.zoom,
        onReady: _ctx.onLeafletReady,
        options: _ctx.mapOptions
      }, {
        default: _withCtx(() => [
          (_ctx.leafletReady)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_l_tile_layer, { url: _ctx.url }, null, 8, ["url"]),
                _createVNode(_component_marker_cluster, { options: { showCoverageOnHover: false, chunkedLoading: true } }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (station) => {
                      return (_openBlock(), _createBlock(_component_l_marker, {
                        key: station.id,
                        "lat-lng": station.latlon,
                        onClick: ($event: any) => (_ctx.openStationDetail(station))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_l_tooltip, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(station?.stationId?.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["lat-lng", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["center", "zoom", "onReady", "options"])
    ])
  ]))
}